import React from 'react'

// The em-dash shown in a Trivvy-list cell that has no value.
//
// Renders exactly the markup the list pages already used inline
// (`<span className="list-empty-dash">&mdash;</span>`) so adopting it is a
// no-op at runtime. `.list-empty-dash` is kept the same size/colour as
// `.survey-createddate-text` on purpose — see the note at
// trivia-survey.css:781-784 — so every "—" across the four lists reads
// identically.
//
// `className` is optional and is appended, never replaced: the cell class
// (e.g. an alignment nudge) can be passed in without losing the dash styling.
const ListEmptyDash = ({ className }) => {
  const classes = className
    ? `list-empty-dash ${className}`
    : 'list-empty-dash'

  return <span className={classes}>&mdash;</span>
}

export default ListEmptyDash
